<template>
  <div v-style="{ bg: backgroundColor, py: paddingsMapping }">
    <div :class="{ 'container ': !isFullWidth }">
      <div v-style:b="borderColor" :class="{ 'b-b': bottomDivider }">
        <h2
          v-if="title"
          v-style:c="titleColor"
          class="mb-4"
          :class="[titleStyle, { 'px-4': !style }]"
        >
          <span v-if="$feature.showTitleHtml" v-html="titleHtml" />
          <span v-else>{{ title }}</span>
        </h2>
        <vf-accordion
          v-for="(accordion, i) in accordions"
          :key="i"
          :border-color
          :icon="iconsStyle"
          :icon-collapse="iconsMap[iconsStyle]"
          :open="accordion.open"
          :title="accordion.title"
          :title-color
          :title-icon="accordion.icon"
          :variant="style"
        >
          <div class="pb-3 ">
            <lazy-cms-rich-text :content="{ richText: accordion.richText }" />
          </div>
        </vf-accordion>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { AccordionsContent } from '#types/components/cms/accordions'
import type { ResponsiveColor } from '#types/content'

const { content } = defineProps<{ content: AccordionsContent }>()
const {
  accordions,
  backgroundColor,
  bottomDivider,
  iconsStyle = 'chevron',
  isFullWidth,
  isJsonldEnabled = false,
  paddings,
  style,
  title,
  titleHtml,
  titleColor,
  titleStyle
} = content

const { ds: { breakpoints }, components: { cms } } = useAppConfig()
const { defaultBorderColor, defaultTitleColor } = useAppConfig().components.cms.accordion
const { componentSpacingMap } = cms.section

const borderColor = Object.keys(breakpoints).reduce((acc, cur) => {
  const valueForBreakpoint = getValueForBreakpoint(cur as keyof ResponsiveColor, titleColor)
  if (valueForBreakpoint?.toLowerCase() !== defaultTitleColor) acc[cur] = valueForBreakpoint
  else acc[cur] = defaultBorderColor
  return acc
}, {} as ResponsiveColor)

const iconsMap = {
  plus: 'minus',
}

const paddingsMapping = Object.keys(breakpoints).reduce((acc, bp) => ({
  ...acc,
  [bp]: componentSpacingMap[paddings?.[bp]]
}), {})

useSchemaOrg(() => {
  if (!isJsonldEnabled) return []

  const faqAccordionSchema = getJsonLdForFaqPage(
    accordions.map((a) => ({
      title: a.title,
      richText: stripHtml(typeof a.richText === 'string' ? a.richText : a.richText.html)
    }))
  )
  return faqAccordionSchema ? [faqAccordionSchema] : []
})
</script>
